import _ from 'lodash';
import { i18n } from './i18n';
import { request } from 'beans-admin-plugin';
import pluralize from 'pluralize';
import { PRODUCT_DESIGN_VIRTUAL_STATES } from '@/constants';

const getValue = ({ item, v }) => {
  return item[v.extra.value_column] || item['id']
}

const getLabel = ({ item, v }) => {
  if (v.extra.model_name === 'User') {
    return item.profile.name
  } else if ((v.extra.model_name === 'Product')) {
    return item.style_number
  } else {
    return item[v.extra.display_column]
  }
}

const components = {
  id: function() {
    return {
      renderCell: {
        component: 'input',
        props: {
          disabled: true
        }
      }
    }
  },
  type: function({ v }) {
    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          options: _.map(v.extra.options, (value) => ({ label: i18n.t(`${_.map(v.model_name.split('::'), str => _.camelCase(str)).join('/')}.types.${value}`), value: value }))
        }
      }
    }
  },
  belongsTo: function({ v }) {
    const requestUrl = `/${pluralize(_.map(v.extra.model_name.split('::'), str => _.snakeCase(str)).join('/'))}/read_options`

    return {
      renderCell: {
        component: 'select',
        attrs: {
          collapseTags: true,
        },
        props: {
          clearable: true,
          xRemotePreload: async () => {
            const { data } = await request.get(requestUrl, { per_page: 100 });
            return data.map(item => ({ value: getValue({ item, v }), label: getLabel({ item, v }) }));
          },
          xRemoteSearch: async (keyword) => {
            const { data } = await request.get(requestUrl, { keyword });
            return data.map(item => ({ value: getValue({ item, v }), label: getLabel({ item, v }) }));
          }
        }
      }
    }
  },
  hasMany: function({ v }) {
    const requestUrl = `/${pluralize(_.map(v.extra.model_name.split('::'), str => _.snakeCase(str)).join('/'))}/read_options`

    return {
      renderCell: {
        component: 'select',
        attrs: {
          collapseTags: true,
        },
        props: {
          clearable: true,
          multiple: true,
          xRemotePreload: async () => {
            const { data } = await request.get(requestUrl, { per_page: 100 });
            return data.map(item => ({ value: getValue({ item, v }), label: getLabel({ item, v }) }));
          },
          xRemoteSearch: async (keyword) => {
            const { data } = await request.get(requestUrl, { keyword });
            return data.map(item => ({ value: getValue({ item, v }), label: getLabel({ item, v }) }));
          }
        }
      }
    }
  },
  enum: function({ v }) {
    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          options: _.map(v.extra.options, (value) => ({ label: i18n.t(`${pluralize(v.label_key_path)}.${value}`), value: value }))
        }
      }
    }
  },
  string: function() {
    return {
      renderCell: {
        component: 'input'
      }
    }
  },
  integer: function () {
    return {
      renderCell: {
        component: 'input',
        props: {
          type: 'number'
        }
      }
    }
  },
  decimal: function () {
    return {
      renderCell: {
        component: 'input',
        props: {
          type: 'number'
        }
      }
    }
  },
  float: function () {
    return {
      renderCell: {
        component: 'input',
        props: {
          type: 'number'
        }
      }
    }
  },
  text: function () {
    return {
      renderCell: {
        component: 'editor',
      }
    }
  },
  boolean: function () {
    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          options: [{ label: '是', value: true }, { label: '否', value: false }]
        }
      }
    }
  },
  date: function () {
    return {
      renderCell: {
        component: 'datePicker',
        props: {
          valueFormat: 'yyyy-MM-dd'
        }
      }
    }
  },
  time: function () {
    return {
      renderCell: {
        component: 'timePicker',
      }
    }
  },
  datetime: function () {
    return {
      renderCell: {
        component: 'dateTimePicker',
      }
    }
  },
  tag: function() {
    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          multiple: true,
          allowCreate: true,
          xRemotePreload: async () => {
            const { data } = await request.get('/acts_as_taggable_on/tags/read_options', { per_page: 100 })
            return _.map(data, ({ name }) => ({ value: name, label: name }))
          },
          xRemoteSearch: async (keyword) => {
            const { data } = await request.get('/acts_as_taggable_on/tags/read_options', { keyword })
            return _.map(data, ({ name }) => ({ value: name, label: name }))
          }
        }
      }
    }
  },
}

export default function(columns) {
  let hash = {}

  _.forEach(columns, (v, k) => {
    if (k === 'state_in' && v.model_name === 'ProductDesign') {
      console.log(v.label_key_path)
      hash[k] = {
        prop: k,
        label: i18n.t('productDesign.state'),
        renderCell: {
          component: 'select',
          attrs: {
            collapseTags: true,
          },
          props: {
            multiple: true,
            clearable: true,
            options: _.map(PRODUCT_DESIGN_VIRTUAL_STATES, (state) => ({ label: i18n.t(`productDesign.states.${state}`), value: state }))
          }
        }
      }
    } else {
      hash[k] = _.merge({
        prop: k,
        label: i18n.t(v.label_key_path),
      }, components[_.camelCase(v.column_type)]({ k, v }))
    }
  })

  return hash
}
